import '../static/IconCard.css';
import React__default from "react";
import clsx from "clsx";
import { c as Heading } from "./Heading.D9qZoTZe.mjs";
import { b as Paragraph } from "./Paragraph.DAcb0zW2.mjs";
import { b as TextLink } from "./TextLink.gdbulXZb.mjs";
import { C as Card } from "./Card.BpXboJlO.mjs";
import { S as SystemIcon } from "./SystemIcon.C2Hwz08D.mjs";
const iconCard = `_iconCard_4358ec8`;
const iconLeft = `_iconLeft_2d1c11b`;
const iconTopLeft = `_iconTopLeft_ca42f31`;
const iconTopCenter = `_iconTopCenter_b2b3fe8`;
const icon = `_icon_efa9b75`;
const sm = `_sm_c20cfe8`;
const lg = `_lg_27d1b05`;
const title = `_title_475fb0f`;
const description = `_description_10ab8c9`;
const link = `_link_61c2677`;
const styles = { iconCard, iconLeft, iconTopLeft, iconTopCenter, icon, sm, lg, title, description, link };
const ICON_CARD_VARIANTS = [
  "iconLeft",
  "iconTopLeft",
  "iconTopCenter"
];
const ICON_SIZES = ["sm", "lg"];
const IconCard = ({
  className,
  background = true,
  icon: icon2,
  title: title2,
  description: description2,
  textLink,
  variant = "iconLeft",
  size = "sm",
  ...props
}) => {
  const { label, ...textLinkProps } = textLink || {};
  return /* @__PURE__ */ React__default.createElement(
    Card,
    {
      ...props,
      hasBackground: background,
      hasPadding: background,
      className: clsx(styles.iconCard, styles[variant], className),
      "data-ui": "icon-card"
    },
    /* @__PURE__ */ React__default.createElement(SystemIcon, { icon: icon2, className: clsx(styles.icon, styles[size]) }),
    title2 && /* @__PURE__ */ React__default.createElement(
      Heading,
      {
        as: "p",
        size: "lg",
        className: styles.title,
        "data-testid": "ui-icon-card-title"
      },
      title2
    ),
    description2 && /* @__PURE__ */ React__default.createElement(
      Paragraph,
      {
        className: styles.description,
        "data-testid": "ui-icon-card-description"
      },
      description2
    ),
    (textLinkProps == null ? void 0 : textLinkProps.href) && /* @__PURE__ */ React__default.createElement(
      TextLink,
      {
        ...textLinkProps,
        className: styles.link,
        arrow: "right",
        "data-testid": "ui-icon-card-link"
      },
      label
    )
  );
};
export {
  ICON_CARD_VARIANTS,
  ICON_SIZES,
  IconCard
};
//# sourceMappingURL=IconCard.CqJlz4ae.mjs.map
